module.exports = __webpack_public_path__ + "img/storage25.2ab0fcc6.jpg";